import { getDonorResetToken } from "appState/auth/authSlice";
import LoginFrame from "assets/images/jpgs/loginframe.jpg";
import { TKIconSpinner } from "assets/images/svgs";
import { useFormik } from "formik";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import CompanyLogo from "shared/CompanyLogo";
import InputField from "shared/InputField";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    isAuthenticated && navigate("/");
  }, [isAuthenticated, navigate]);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    onSubmit: (values) => {
      const body = {
        email: values.email,
      };
      dispatch(getDonorResetToken(body)).then((data) => {
        toast.success(
          `A link to reset your password has been sent to ${body.email}!`
        );
      });
    },
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div>
      <div className="w-full h-full flex max-md:flex-wrap items-center gap-8">
        <div className="relative w-[60%] max-md:w-full max-md:h-[500px] h-screen">
          <img
            className="w-full h-full object-cover"
            src={LoginFrame}
            alt="TK-LoginFrame"
          />
          <p className="px-8 absolute bottom-10 max-md:text-[14px] text-[28px] text-white font-semibold shadow-md">
            Speak up for those who cannot speak for themselves, for the rights
            of all who are destitute. Speak up and judge fairly; defend the
            rights of the poor and needy.
          </p>
        </div>
        <div className="px-4 w-[40%] max-md:w-full flex flex-col justify-center items-start gap-4">
          <div className="mb-4">
            <CompanyLogo blue />
          </div>
          <div className="mb-2 w-full">
            <p className="text-[20px] font-bold mb-2">Reset Password</p>
            <div className="flex items-center justify-start gap-2">
              <NavLink to="/auth/donor/login">
                <p className="underline text-[#213874] font-medium hover:font-semibold">
                  Back to login
                </p>
              </NavLink>
            </div>
          </div>
          <form onSubmit={formik.handleSubmit} className="w-full">
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-2">
                <label className="text-[14px] font-normal">Email Address</label>
                <InputField
                  className="border border-[#E6E6E6] rounded-md"
                  type="email"
                  name="email"
                  placeholder="exampleforyou@info.com"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
              </div>
              <div>
                <button
                  type="submit"
                  className="w-full h-[50px] rounded-lg bg-[#213874] hover:bg-[#182d62] px-4 py-2 flex items-center justify-center"
                >
                  <p className="text-white font-semibold">
                    {isLoading ? <TKIconSpinner /> : "Forgot Password"}
                  </p>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
